export default __webpack_public_path__ + "static/media/headshot.185509b0.png";